import  { actions } from '../constants/modal';

export const setModalOpen = (
  isModalOpen: boolean
) => ({
  isModalOpen,
  type: actions.SET_MODAL_TOGGLE
});
